import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from "../../utils/gqlClient";
import { wrapQuery } from "../../utils/wrapQuery";
import { getResetPasswordRedirect } from "../../utils/config";
export { sendResetPasswordEmail };
var sendResetPasswordEmailMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query SendResetPasswordEmail($clientId: String!, $email: String!, $redirect: String) {\n    sendResetPasswordEmail(clientId: $clientId, email: $email, redirect: $redirect) {\n      status\n      token\n    }\n  }\n"])));
async function sendResetPasswordEmail(clientId, email) {
  var data = await wrapQuery('sendResetPasswordEmail', sendResetPasswordEmailMutation, {
    clientId: clientId,
    email: email,
    redirect: getResetPasswordRedirect()
  });
  return data.sendResetPasswordEmail;
}